import { SpAlert } from '../../../../components/sp-alert/sp-alert.model';

export class Controller {

    /** @ngInject */
    constructor(RegistrationProfile) {
        this.RegistrationProfile = RegistrationProfile;
    }

    $onInit() {
        this.activeEmails = this.resolve.activeEmails;
        this.profile = {};
    }

    save() {
        this.RegistrationProfile
            .save(this.profile).$promise
            .then((profile) => this.close({$value: profile}))
            .catch((response) => {
                this.spAlert = new SpAlert('danger', response.data.message);
            });
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/add/add.controller.js